import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Endpoints from "../../api/endpoints";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import { Alert, Spin } from "antd";

// Import components
import ShopInformation from "./components/ShopInformation";
import BillingInformation from "./components/BillingInformation";
import CardInformation from "./components/CardInformation";
import OfficerInformation from "./components/OfficerInformation";
import PersonnelList from "./components/PersonnelList";
import SubscriptionInformation from "./components/SubscriptionInformation";
import ShopStatistics from "./components/ShopStatistics";
import TierBadge from "./components/TierBadge";

const ShopDetails = () => {
  const params = useParams();
  const shopId = params.shopId;
  const axiosPrivate = useAxiosPrivate();
  const [shop, setShop] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sectors, setSectors] = useState([]);
  const [isSectorLoading, setIsSectorLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshData = () => {
    setRefreshKey((prev) => prev + 1);
  };

  console.log("shop", shop);
  useEffect(() => {
    const fetchShop = async () => {
      setIsLoading(true);
      try {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getShop,
          axiosPrivate: axiosPrivate,
          httpParams: { id: shopId },
        });
        setShop(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchSectors = async () => {
      try {
        setIsSectorLoading(true);
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getAllSectors,
          axiosPrivate: axiosPrivate,
        });
        const sectorData = response.data.map((sector) => ({
          value: sector.id,
          label: sector.description,
        }));
        setSectors(sectorData);
      } catch (error) {
        console.log(error);
      } finally {
        setIsSectorLoading(false);
      }
    };

    fetchShop();
    fetchSectors();
  }, [refreshKey]);

  if (error) {
    return (
      <Alert
        message="Hata"
        description="Mağaza bilgileri yüklenemedi"
        type="error"
        showIcon
      />
    );
  }

  return (
    <Spin spinning={isLoading}>
      <div style={{ padding: "20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
          }}>
          <h1 style={{ margin: 0 }}>
            Mağaza Detayları
            {shop?.shopDetails?.name ? ` — ${shop.shopDetails.name}` : ""}
          </h1>
          {shop?.shopSubscriptionDetails && (
            <TierBadge tier={shop.shopSubscriptionDetails.tier} />
          )}
        </div>

        <ShopInformation
          initialValues={shop?.shopDetails}
          isLoading={isLoading}
          sectors={sectors}
          isSectorLoading={isSectorLoading}
          shopId={shopId}
          onSuccess={refreshData}
        />

        <BillingInformation
          initialValues={shop?.shopBillingInfoDetails}
          isLoading={isLoading}
          shopId={shopId}
          onSuccess={refreshData}
        />

        <CardInformation
          initialValues={shop?.shopCardDetails}
          isLoading={isLoading}
          shopId={shopId}
          onSuccess={refreshData}
        />

        <OfficerInformation
          initialValues={shop?.shopOfficerDetails}
          isLoading={isLoading}
          shopId={shopId}
          onSuccess={refreshData}
        />

        <PersonnelList shop={shop} onSuccess={refreshData} />

        <SubscriptionInformation shop={shop} onSuccess={refreshData} />
        <ShopStatistics statistics={shop?.statistics} isLoading={isLoading} />
      </div>
    </Spin>
  );
};

export default ShopDetails;
